import axios from '@/axios'

/**
 * 통계 API 서비스
 */
export const statisticsService = {
  /**
   * 일일 통계 조회
   * @param {string} date - 날짜 (YYYY-MM-DD)
   * @returns {Promise}
   */
  getDailyStatistics(date) {
    return axios.get('/admin/statistics/daily', { params: { date } })
  },

  /**
   * 주간 통계 조회
   * @param {string} weekStartDate - 주 시작일 (YYYY-MM-DD)
   * @returns {Promise}
   */
  getWeeklyStatistics(weekStartDate) {
    return axios.get('/admin/statistics/weekly', { params: { weekStartDate } })
  },

  /**
   * 월간 통계 조회
   * @param {string} monthStartDate - 월 시작일 (YYYY-MM-DD)
   * @returns {Promise}
   */
  getMonthlyStatistics(monthStartDate) {
    return axios.get('/admin/statistics/monthly', { params: { monthStartDate } })
  },

  /**
   * 전체 통계 조회
   * @returns {Promise}
   */
  getTotalStatistics() {
    return axios.get('/admin/statistics/total')
  },

  /**
   * 최근 N일 통계 조회
   * @param {string} statType - 통계 타입 (DAILY, WEEKLY, MONTHLY)
   * @param {number} days - 조회할 일수 (기본값 30)
   * @returns {Promise}
   */
  getRecentStatistics(statType, days = 30) {
    return axios.get('/admin/statistics/recent', { params: { statType, days } })
  },

  /**
   * 기간별 통계 조회
   * @param {string} statType - 통계 타입
   * @param {string} startDate - 시작일 (YYYY-MM-DD)
   * @param {string} endDate - 종료일 (YYYY-MM-DD)
   * @returns {Promise}
   */
  getStatisticsByDateRange(statType, startDate, endDate) {
    return axios.get('/admin/statistics/range', {
      params: { statType, startDate, endDate }
    })
  },

  /**
   * 수동 일일 통계 생성
   * @param {string} date - 날짜 (YYYY-MM-DD)
   * @returns {Promise}
   */
  generateDailyStatistics(date) {
    return axios.post('/admin/statistics/generate/daily', null, { params: { date } })
  },

  /**
   * 수동 주간 통계 생성
   * @param {string} weekStartDate - 주 시작일 (YYYY-MM-DD)
   * @returns {Promise}
   */
  generateWeeklyStatistics(weekStartDate) {
    return axios.post('/admin/statistics/generate/weekly', null, { params: { weekStartDate } })
  },

  /**
   * 수동 월간 통계 생성
   * @param {string} monthStartDate - 월 시작일 (YYYY-MM-DD)
   * @returns {Promise}
   */
  generateMonthlyStatistics(monthStartDate) {
    return axios.post('/admin/statistics/generate/monthly', null, { params: { monthStartDate } })
  },

  /**
   * 수동 전체 통계 생성
   * @returns {Promise}
   */
  generateTotalStatistics() {
    return axios.post('/admin/statistics/generate/total')
  }
}

export default statisticsService
